import React, { useState } from 'react';
import SkeletonElement from './skeletons/SkeletonElement';
import { cloudinaryOptimiseParams, getCloudinaryUrl } from '../utils/helpers/getCloudinaryUrl';
import { IDimensions } from './interfaces/IImageContainer';

interface Props {
  src?: string
  className?: string
  size?: IDimensions
  params?: Array<string>
  alt: string
  placeholder?: string
  skeletonType?: string
}

const ImageContainer = ({
  src = '',
  className: cn = '',
  size = {},
  params = [],
  alt,
  placeholder,
  skeletonType = 'image',
}: Props) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const { width, height } = size;

  const className = `img-fluid ${cn} ${!isImageLoaded ? 'd-none' : ''}`;

  if (width && !params.some((p) => p.startsWith('w_'))) params.push(`w_${width}`);
  if (height && !params.some((p) => p.startsWith('h_'))) params.push(`h_${height}`);

  const image = src ? getCloudinaryUrl(src, [...params, ...cloudinaryOptimiseParams]) : placeholder;

  const onImageLoad = () => {
    setIsImageLoaded(true);
  };

  return (
    <>
      <img
        className={className}
        src={image}
        alt={alt}
        onLoad={onImageLoad}
      />
      {!isImageLoaded && <SkeletonElement type={skeletonType} style={size} />}
    </>
  );
};

export default ImageContainer;
